import React from 'react'
import {  Link, useLoaderData } from "react-router-dom";

function PageWithData(props) {

  let pageData = useLoaderData();
console.log(pageData);
  return (

<section>

      <div  className="relative items-center h-[20vh]">
        <h1 style={{fontSize:'300%'}} className="text-center w-full pt-[20vh]  text-white"></h1>
    </div>

    <div className={"flex flex-col justify-between px-8 md:px-24" + props.transition}>
    <div className="pt-16 mb-16 md:mx-24">
<div className="text-white" dangerouslySetInnerHTML={{__html: pageData.content[0] }}/>
</div>
</div>

</section>
  )
}

export default PageWithData
